import {
  Wind,
  Waves,
  Refrigerator,
  Droplets,
  Tv,
  Wrench,
  Zap,
  Hammer,
  Sparkles,
} from 'lucide-react'

export const CATEGORIES = [
  { id: 'aircon', name: 'Aircon', icon: Wind, disabled: false },
  { id: 'handyman', name: 'Handyman', icon: Hammer, disabled: false },
  { id: 'cleaning', name: 'Cleaning', icon: Sparkles, disabled: false },
  { id: 'plumbing', name: 'Plumbing', icon: Wrench, disabled: true },
  {
    id: 'washing-machine',
    name: 'Washing Machine',
    icon: Waves,
    disabled: true,
  },
  {
    id: 'refrigerator',
    name: 'Refrigerator',
    icon: Refrigerator,
    disabled: true,
  },
  { id: 'water-heater', name: 'Water Heater', icon: Droplets, disabled: true },
  { id: 'tv-appliance', name: 'TV / Home Appliance', icon: Tv, disabled: true },
]

export const MALAYSIA_STATES = [
  { value: 'kl', label: 'Kuala Lumpur', disabled: false },
  { value: 'selangor', label: 'Selangor (Coming Soon)', disabled: true },
  { value: 'penang', label: 'Penang (Coming Soon)', disabled: true },
  { value: 'johor', label: 'Johor (Coming Soon)', disabled: true },
  // Add others as needed, keeping it simple for MVP
]
